import type { NavItemProps } from "@lifepal/lifepal-design-system/build/components/Navbar";

export const MAIN_NAV:  NavItemProps[] = [
  {
    "title": "Produk Asuransi",
    "link": "https://lifepal.co.id/asuransi/",
    "childItems": [
      {
        "title": "Kendaraan",
        "link": "/asuransi/kendaraan/",
        "childItems": [
          {
            "title": "Asuransi Mobil",
            "link": "/asuransi/mobil/",
          },
          {
            "title": "Asuransi Motor",
            "link": "/asuransi/motor/",
          },
          {
            "title": "Asuransi TLO",
            "link": "/asuransi/tlo/",
          },
          {
            "title": "Asuransi All Risk",
            "link": "/asuransi/all-risk/",
          }
        ],
      },
      {
        "title": "Kesehatan",
        "link": "/asuransi/kesehatan/",
        "childItems": [
          {
            "title": "Asuransi Kesehatan",
            "link": "/asuransi/kesehatan/",
          },
          {
            "title": "Asuransi Keluarga",
            "link": "/asuransi/kesehatan-keluarga/",
          },
          {
            "title": "Asuransi Karyawan",
            "link": "/asuransi/karyawan/",
          },
          {
            "title": "Asuransi Rawat Jalan",
            "link": "/asuransi/rawat-jalan/",
          },
          {
            "title": "Asuransi Melahirkan",
            "link": "/asuransi/melahirkan/",
          },
          {
            "title": "Asuransi Gigi",
            "link": "/asuransi/gigi/",
          },
          {
            "title": "Asuransi Penyakit Kritis",
            "link": "/asuransi/penyakit-kritis/",
          },
          {
            "title": "Asuransi Kesehatan Syariah",
            "link": "/asuransi/kesehatan-syariah/",
          },
          {
            "title": "Hospital Cash Plan",
            "link": "/asuransi/hospital-cash-plan/",
          }
        ],
      },
      {
        "title": "Jiwa",
        "link": "/asuransi/jiwa/",
        "childItems": [
          {
            "title": "Asuransi Jiwa",
            "link": "/asuransi/jiwa/",
          },
          {
            "title": "Asuransi Kecelakaan",
            "link": "/asuransi/kecelakaan/",
          },
          {
            "title": "Asuransi Unitlink",
            "link": "/asuransi/unit-link/",
          },
          {
            "title": "Asuransi Dwiguna",
            "link": "/asuransi/dwiguna/",
          },
          {
            "title": "Asuransi Jiwa Premi Kembali",
            "link": "/asuransi/jiwa-rop/",
          }
        ],
      },
      {
        "title": "Lainnya",
        "link": "/asuransi/",
        "childItems": [
          {
            "title": "Asuransi Perjalanan",
            "link": "/asuransi/perjalanan/",
          },
          {
            "title": "Asuransi Pendidikan",
            "link": "/asuransi/pendidikan/",
          },
          {
            "title": "Asuransi Properti",
            "link": "/asuransi/properti/",
          },
          {
            "title": "Asuransi Syariah",
            "link": "/asuransi/syariah/",
          }
        ],
      },
      {
        "title": "Dapatkan Penawaran",
        "link": "/penawaran",
      }
    ],
  },
  {
    "title": "Artikel & Tips",
    "link": "https://lifepal.co.id/media/",
    "childItems": [
      {
        "title": "Mengerti Asuransi",
        "link": "/media/category/asuransi/",
        "childItems": [
          {
            "title": "Apa Itu Asuransi",
            "link": "/media/apa-itu-asuransi/",
          },
          {
            "title": "Polis Asuransi",
            "link": "/media/polis-asuransi/",
          },
          {
            "title": "Premi Asuransi",
            "link": "/media/apa-itu-premi-asuransi/",
          },
          {
            "title": "Jenis Asuransi",
            "link": "/media/jenis-asuransi/",
          },
          {
            "title": "Resiko Asuransi",
            "link": "/media/risiko-asuransi/",
          },
          {
            "title": "Klaim Asuransi",
            "link": "/media/klaim-asuransi/",
          },
          {
            "title": "Pentingnya Asuransi",
            "link": "/media/melihat-pentingnya-asuransi-bagi-masa-depan-keuangan-anda/",
          },
          {
            "title": "Istilah Asuransi Lainnya",
            "link": "/media/istilah-dalam-asuransi/",
          }
        ],
      },
      {
        "title": "Memilih dan Membeli",
        "link": "/media/panduan-asuransi/",
        "childItems": [
          {
            "title": "Memilih Asuransi Kesehatan",
            "link": "/media/bingung-memilih-asuransi-kesehatan-yang-tepat-mungkin-bisa-lakukan-ini/",
          },
          {
            "title": "Memilih Asuransi Mobil",
            "link": "/media/pilihan-asuransi-mobil-murah/",
          },
          {
            "title": "Memilih Asuransi Jiwa",
            "link": "/media/asuransi-jiwa-terbaik-di-indonesia/",
          },
          {
            "title": "Perbedaan All Risk dan TLO",
            "link": "/media/beda-benefit-tlo-risk-dan-kombinasi-plus-cara-hitung-preminya/",
          },
          {
            "title": "Rate Asuransi Mobil",
            "link": "https://lifepal.co.id/media/rate-asuransi-mobil/",
          },
          {
            "title": "Asuransi Kesehatan Murni",
            "link": "/media/mau-tahu-asuransi-kesehatan-yang-bagus-lihat-daftar-ini/",
          },
          {
            "title": "Jiwa Berjangka vs Seumur Hidup",
            "link": "/media/term-life/",
          }
        ],
      },
      {
        "title": "Artikel Lainnya",
        "link": "/media/",
        "childItems": [
          {
            "title": "Asuransi",
            "link": "/media/category/asuransi/",
          },
          {
            "title": "Kesehatan",
            "link": "/media/category/kesehatan/",
          },
          {
            "title": "Kendaraan",
            "link": "/media/category/kendaraan/",
          },
          {
            "title": "Tabungan",
            "link": "/media/category/tabungan/",
          },
          {
            "title": "Investasi",
            "link": "/media/category/asuransi/",
          },
          {
            "title": "Kredit",
            "link": "/media/category/kredit/",
          },
          {
            "title": "Administrasi",
            "link": "/media/category/administrasi/",
          },
          {
            "title": "Keuangan",
            "link": "/media/category/perencanaan/",
          }
        ],
      }
    ],
  },
  {
    "title": "Perangkat",
    "link": "https://lifepal.co.id/",
    "childItems": [
      {
        "title": "Cari Bengkel",
        "link": "/bengkel-mobil/",
      },
      {
        "title": "Urus Pajak Mobil",
        "link": "/pajak-mobil/",
      },
      {
        "title": "Cek Keuangan",
        "link": "/cek-keuangan",
      },
      {
        "title": "Tanya Lifepal",
        "link": "/tanya/",
      },
      {
        "title": "Kalkulator & Kuis",
        "link": "/media/category/kalkulator",
      }
    ],
  },
  {
    "title": "Bantuan",
    "link": "/pusat-bantuan/",
    "position": "right",
    "childItems": [
      {
        "title": "Pusat Bantuan",
        "link": "/pusat-bantuan/",
      },
      {
        "title": "Ketentuan",
        "link": "/ketentuan/",
      },
      {
        "title": "FAQ",
        "link": "https://lifepalhelp.zendesk.com/hc/id",
      }
    ],
  }
];